import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { SelectItem } from 'primeng/api';
import {
  Validators,
  FormControl,
  FormGroup,
  FormBuilder,
} from '@angular/forms';
import { BroadcastService } from '../../../../../services/broadcast.service';

import { ShopRidesService } from '../../../../../services/shoprides.service';
import { HelpersService } from '../../../../../services/helpers.service';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { OverlayPanel } from 'primeng/overlaypanel';
import { Button } from 'primeng/button';
import { Dialog } from 'primeng/dialog';

@Component({
  selector: 'app-create-edit-ride',
  templateUrl: './create-edit-ride.component.html',
  styleUrls: ['./create-edit-ride.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CreateEditRideComponent implements OnInit {
  @Input() rideID;
  @Output() close = new EventEmitter();

  public weekDays: any = {
    Monday: false,
    Tuesday: false,
    Wednesday: false,
    Thursday: false,
    Friday: false,
    Saturday: false,
    Sunday: false,
  };

  public rideTypes: SelectItem[] = [
    {
      label: this.translate.instant('bikeshop.shop_rides.ride_types.bmx'),
      value: 'bmx',
    },
    {
      label: this.translate.instant('bikeshop.shop_rides.ride_types.downhill'),
      value: 'downhill',
    },
    { label: 'E-Bike', value: 'e-bike' },
    {
      label: this.translate.instant('bikeshop.shop_rides.ride_types.gravel'),
      value: 'gravel',
    },
    {
      label: this.translate.instant('bikeshop.shop_rides.ride_types.mountain'),
      value: 'mountain',
    },
    {
      label: this.translate.instant('bikeshop.shop_rides.ride_types.road'),
      value: 'road',
    },
    {
      label: this.translate.instant('bikeshop.shop_rides.ride_types.social'),
      value: 'social',
    },
  ];

  public rideForm: FormGroup;
  public participatingGroups: any = [];
  public ride: any = {};

  public selectedRoutInfo = 'Upload File';
  public loading: boolean = true;
  public selectedRoute: string;
  public buttonDisabled = false;
  public showRouteNamePrompt = false;
  public downloadLoading: boolean = false;

  public routeName = '';
  public rideRoutes: any = [];
  public rideGroups: any = [];
  public rideRoute: any = {};
  public groupUpdate: any = {};
  public gpx: any = null;
  public partner: any = {};
  public distanceUnit = 'Km';
  public speedUnit = 'Km/h';
  public elevationUnit = 'm';
  public minDate = new Date();
  public base64File = '';
  public posterImg = '';
  public mediaImages: any = [];

  constructor(
    private fb: FormBuilder,
    public shopRidesService: ShopRidesService,
    public helpersService: HelpersService,
    public broadcastService: BroadcastService,
    public messageService: MessageService,
    public route: ActivatedRoute,
    public router: Router,
    public translate: TranslateService,
    private confirmationService: ConfirmationService,
  ) {}

  ngOnInit() {
    this.partner = this.helpersService.getPartnerData();
    if (this.partner.DefaultUnitOfMeasure === 2) {
      this.distanceUnit = 'mi';
      this.speedUnit = 'mph';
      this.elevationUnit = 'ft.';
    }
    this.loading = true;
    if (this.rideID > 0) {
      this.shopRidesService.getRide(this.rideID).subscribe((ride) => {
        this.ride = ride;
        this.posterImg = ride.posterImageURL;
        this.selectedRoute = ride.bikeShopRideRouteID;
        this.mediaImages = ride.mediaImages;
        this.setupForm();
        this.loading = false;
      });
    } else {
      this.ride = { active: true };
      this.setupForm();
      this.loading = false;
    }
    this.getRideRoutes();
    this.getRideGroups();
  }

  setupForm() {
    this.rideForm = this.fb.group({
      name: new FormControl(
        this.ride.name ? this.ride.name : '',
        Validators.required,
      ),
      location: new FormControl(
        this.ride.location ? this.ride.location : '',
        Validators.required,
      ),
      selectedRideType: new FormControl(
        this.ride.rideType ? this.ride.rideType : this.rideTypes[0].value,
        Validators.required,
      ),
      date: new FormControl(
        this.ride.startTime ? moment(this.ride.startTime).toDate() : '',
        Validators.required,
      ),
      endDate: new FormControl('', Validators.nullValidator),
      time: new FormControl(
        this.ride.startTime
          ? moment(this.ride.startTime).toDate()
          : new Date(new Date(new Date().setHours(7)).setMinutes(0)),
        Validators.required,
      ),
      repeat: new FormControl(false, Validators.nullValidator),
      repeatWeeks: new FormControl(1, Validators.required),
      description: new FormControl(
        this.ride.description ? this.ride.description : '',
        Validators.nullValidator,
      ),
      active: new FormControl(this.ride.active, Validators.required),
      routeName: new FormControl('', Validators.nullValidator),
    });
  }

  getRideRoutes() {
    this.shopRidesService
      .getRideRoutes(this.helpersService.getPartnerId())
      .subscribe((rideRoutes) => {
        this.rideRoutes = rideRoutes;
      });
  }

  getRideGroups() {
    this.shopRidesService
      .getRideGroups(this.helpersService.getPartnerId())
      .subscribe((groups) => {
        this.rideGroups = groups;
      });
  }

  getRideRoute(RideRouteID) {
    var route = this.rideRoutes
      .filter((x) => {
        return x.id === RideRouteID;
      })
      .pop();
    if (route) {
      this.ride.distance = Math.round(route.distance);
      this.ride.bikeShopRideRouteID = RideRouteID;
    }
  }

  saveRide(value) {
    if (this.ride && this.ride.id) {
      if (this.ride.hasLinkedRides) {
        this.confirmationService.confirm({
          key: 'shop_ride',
          rejectLabel: this.translate.instant('general.no'),
          acceptLabel: this.translate.instant('general.ok'),
          message: this.translate.instant(
            'bikeshop.shop_rides.update_linked_rides',
          ),
          accept: () => {
            this.updateRide(value, true);
          },
          reject: () => {
            this.updateRide(value);
          },
        });
      } else {
        this.updateRide(value);
      }
    } else {
      this.createRide(value);
    }
  }

  updateRide(value, updateLinkedRides = false) {
    this.buttonDisabled = true;
    var ride = {
      ...this.ride,
      ...{
        name: value.name,
        location: value.location,
        description: value.description,
        updateLinkedRides: updateLinkedRides,
        startTime: moment(
          new Date(
            new Date(
              new Date(value.date).setHours(new Date(value.time).getHours()),
            ).setMinutes(new Date(value.time).getMinutes()),
          ),
        ).format('YYYY-MM-DDTHH:mm:ss'),
        rideType: value.selectedRideType,
        active: value.active,
        public: value.public,
        ImageData: this.base64File,
      },
    };

    this.shopRidesService.updateRide(ride).subscribe(
      (updatedRide) => {
        this.buttonDisabled = false;
        this.messageService.add({ life: 5000, detail: 'Ride updated' });
        this.close.emit();
      },
      (err) => {
        this.buttonDisabled = false;
        this.messageService.add({
          life: 5000,
          detail: 'There was an error saving the ride.',
        });
      },
    );
  }

  createRide(value) {
    this.buttonDisabled = true;
    var ride = {
      ...this.ride,
      ...{
        partnerID: this.partner.ID,
        name: value.name,
        location: value.location,
        description: value.description,
        startTime: moment(
          new Date(
            new Date(
              new Date(value.date).setHours(new Date(value.time).getHours()),
            ).setMinutes(new Date(value.time).getMinutes()),
          ),
        ).format('YYYY-MM-DDTHH:mm:ss'),
        rideType: value.selectedRideType,
        active: value.active,
        public: value.public,
        repeat: value.repeat,
        ImageData: this.base64File,
      },
    };

    if (value.repeat) {
      ride['Repeat'] = true;
      ride['WeekDays'] = this.weekDays;
      ride['RepeatWeeks'] = value.repeatWeeks;
      ride['RepeatEndDate'] = new Date(
        new Date(new Date(value.endDate).setHours(23)).setMinutes(59),
      );
    }

    this.shopRidesService.createRide(ride).subscribe(
      (updatedRide) => {
        this.buttonDisabled = false;
        this.messageService.add({ life: 5000, detail: 'Ride updated' });
        this.close.emit();
      },
      (err) => {
        this.buttonDisabled = false;
        this.messageService.add({
          life: 5000,
          detail: 'There was an error saving the ride.',
        });
      },
    );
  }

  checkValidation() {
    var repeatValidated = false;
    repeatValidated =
      !this.rideForm.value.repeat ||
      (this.rideForm.value.repeat &&
        this.rideForm.value.endDate &&
        (this.weekDays.Monday ||
          this.weekDays.Tuesday ||
          this.weekDays.Wednesday ||
          this.weekDays.Thursday ||
          this.weekDays.Friday ||
          this.weekDays.Saturday ||
          this.weekDays.Sunday));

    return (
      this.rideForm.valid &&
      this.ride.groups &&
      this.ride.groups.length > 0 &&
      this.ride.distance > 0 &&
      repeatValidated
    );
  }

  listRideGroups() {
    return this.rideGroups && this.rideGroups.length > 0
      ? this.rideGroups.filter((x) => {
          return x.type === this.rideForm.value.selectedRideType;
        })
      : [];
  }

  toggleGroupSelection(group) {
    if (!this.ride.groups) {
      this.ride.groups = [];
    }
    if (this.ride.groups.indexOf(group.id) === -1) {
      this.ride.groups.push(group.id);
    } else {
      var index = this.ride.groups.indexOf(group.id);
      this.ride.groups.splice(index, 1);
    }
  }

  uploadGPX(event, uploadGPXButton) {
    let uploadFile = event.target.files[0];
    var reader = new FileReader();
    reader.readAsText(uploadFile);
    reader.onload = (file: any) => {
      // this.mapService.plotGpx(file.target.result, distance=>{
      //   this.ride.distance = distance;
      // });
      this.gpx = file.target.result;
      this.showRouteNamePrompt = true;
    };
  }

  saveRoute(event, routeNamePrompt: Dialog) {
    var data = {
      PartnerID: this.helpersService.getPartnerId(),
      RouteName: this.routeName,
      GPXData: this.gpx,
    };
    this.shopRidesService.createRoute(data).subscribe((result) => {
      this.selectedRoute = result.id;
      this.ride.bikeShopRideRouteID = result.id;
      this.ride.distance = Math.round(result.distance);
      this.getRideRoutes();
    });
    routeNamePrompt.close(event);
  }

  deleteRoute(route) {
    this.confirmationService.confirm({
      key: 'shop_ride',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: this.translate.instant('general.yes'),
      rejectLabel: this.translate.instant('general.no'),
      message: this.translate.instant(
        'bikeshop.shop_rides.delete_route_confirmation',
      ),
      accept: () => {
        if (this.selectedRoute == route.id) {
          this.selectedRoute = null;
        }
        this.shopRidesService.deleteRideRoute(route.id).subscribe((res) => {
          this.getRideRoutes();
        });
      },
    });
  }

  downloadRoute(route: any) {
    this.downloadLoading = true;
  
    this.shopRidesService.downloadRideRouteGpx(route.id).subscribe(
      (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${route.routeName}.gpx`;
        a.click();
        window.URL.revokeObjectURL(url);
        this.downloadLoading = false;
      },
      (error) => {
        console.error('Download error:', error);
        this.downloadLoading = false;
      }
    );
  }

  manageGroup(event, groupPanel: OverlayPanel, group, target) {
    if (group === null) {
      this.groupUpdate = {
        partnerID: this.partner.ID,
        averageSpeed: 0,
        minimumSpeed: 0,
        type: this.rideForm.value.selectedRideType,
      };
    } else {
      this.groupUpdate = group;
    }
    groupPanel.toggle(event, target);
  }

  saveGroup(groupPanel: OverlayPanel) {
    groupPanel.hide();
    if (this.groupUpdate.id > 0) {
      this.shopRidesService
        .updateRideGroup(this.groupUpdate)
        .subscribe((result) => {
          this.getRideGroups();
        });
    } else {
      this.shopRidesService
        .createRideGroup(this.groupUpdate)
        .subscribe((result) => {
          this.getRideGroups();
        });
    }
  }

  removeGroup(groupPanel: OverlayPanel) {
    groupPanel.hide();
    if (this.groupUpdate.id > 0) {
      this.shopRidesService
        .updateRideGroup({ ...this.groupUpdate, active: false })
        .subscribe((result) => {
          this.getRideGroups();
        });
    }
  }

  cancel() {
    this.close.emit();
  }

  posterUploader(event) {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      this.posterImg = reader.result.toString();
      this.base64File = reader.result
        .toString()
        .replace(/^data:(.*;base64,)?/, '');
    };
  }

  async uploadMediaImages(event) {
    if (event.target.files && event.target.files.length > 0) {
      for (var i = 0; i < event.target.files.length; i++) {
        var file = event.target.files[i];
        const reader = new FileReader();
        await reader.readAsDataURL(file);
        reader.onload = async () => {
          var data = {
            RideID: this.rideID,
            GroupID: this.ride.groups[0], //For now just uploading to the first group, we don't actually show images but group anywhere
            Image: reader.result.toString().replace(/^data:(.*;base64,)?/, ''),
          };
          await this.shopRidesService
            .addShopRideGroupImage(data)
            .subscribe((result) => {
              this.mediaImages.unshift(result);
            });
        };
      }
    }
  }

  removeImage(index, image) {
    this.shopRidesService
      .deleteShopRideGroupImage(image.id)
      .subscribe((res) => {
        this.mediaImages.splice(index, 1);
      });
  }
}
